import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo2.png';

const _withScopeId = n => (_pushScopeId("data-v-153c1e0b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "register-container"
};
const _hoisted_2 = {
  class: "register-content"
};
const _hoisted_3 = {
  style: {
    "padding": "15px"
  }
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "50px"
  }
})], -1));

const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  class: "label"
};
const _hoisted_8 = {
  style: {
    "padding": "15px"
  }
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "50px"
  }
})], -1));

const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  class: "label"
};
const _hoisted_13 = {
  class: "btn"
};
const _hoisted_14 = {
  class: "indicator"
};
const _hoisted_15 = {
  class: "register-to"
};
const _hoisted_16 = {
  class: "strong"
};
const _hoisted_17 = {
  class: "tip"
};
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Toast } from 'vant';
import 'vant/es/toast/style';
import NavGradient from '@/components/NavGradient.vue';
import CheckPopup from '@/components/CheckPopup.vue';
import { register, registerSend } from '@/apis';
import { useI18n } from "vue-i18n";
export default {
  __name: 'RegisterView',

  setup(__props) {
    const {
      t
    } = useI18n();
    const router = useRouter();
    const store = useStore();
    const route = useRoute();
    const email = ref('');
    const loginPwd = ref('');
    const financePwd = ref('');
    const inviteCode = ref('96242829');
    const captcha = ref('123123');
    const checkShow = ref(false);
    const nextLoading = ref(false); // const captchaId = ref('')
    // const captchaImg = ref('')

    const checkCode = ref('');
    const countDown = ref(null);
    const countTime = ref(false);
    const sendLoading = ref(false);
    const time = ref(1000 * 60);
    const tabActive = ref(0);

    if (route.query.code) {
      inviteCode.value = route.query.code;
    } // const init = async () => {
    //   const res = await getCaptcha()
    //   if (res.code === 200) {
    //     captchaId.value = res.data.id
    //     captchaImg.value = res.data.img
    //   }
    // }


    onMounted(() => {
      // init()
      if (route.query.email != '') {
        email.value = route.query.email;
      }
    });

    const showEmailCheck = () => {
      if (email.value === '') {
        Toast({
          message: t('emailInput'),
          position: 'bottom'
        });
        return;
      }

      if (checkCode.value === '') {
        Toast({
          message: t('checkCodeInput'),
          position: 'bottom'
        });
        return;
      }

      if (inviteCode.value === '') {
        Toast({
          message: t('inviteCodeTip'),
          position: 'bottom'
        });
        return;
      } // if (captcha.value === '') {
      //   Toast({ message: t('imageCodeInput'), position: 'bottom' })
      //   return
      // }
      // checkShow.value = true


      tabActive.value = 1;
    };

    const next = async () => {
      if (loginPwd.value === '') {
        Toast({
          message: t('loginPwdTip'),
          position: 'bottom'
        });
        return;
      }

      if (loginPwd.value.length < 8 || loginPwd.value.length > 20) {
        Toast({
          message: t('loginPwdLen'),
          position: 'bottom'
        });
        return;
      }

      if (financePwd.value === '') {
        Toast({
          message: t('financePwdTip'),
          position: 'bottom'
        });
        return;
      }

      if (financePwd.value.length < 6 || financePwd.value.length > 20) {
        Toast({
          message: t('financePwdLen'),
          position: 'bottom'
        });
        return;
      }

      nextLoading.value = true;
      const res = await register({
        email: email.value.replace(' ', ''),
        code: checkCode.value.trim(),
        password: loginPwd.value,
        inviteCode: inviteCode.value.trim(),
        fundPassword: financePwd.value
      });
      nextLoading.value = false;

      if (res.code !== 200) {
        Toast({
          message: res.msg !== '' ? res.msg : t('registerError'),
          position: 'bottom'
        });
        return;
      }

      if (res.token) {
        store.commit('tokenChange', res.token);
        store.commit('emailChange', email.value);
        localStorage.setItem('astore_info', JSON.stringify({
          token: res.token,
          time: Math.round(new Date().getTime() / 1000),
          email: email.value
        }));
      }

      Toast({
        message: t('registerSuccess'),
        position: 'bottom'
      });
      router.replace({
        name: 'home'
      });
    };

    const sendCheckCode = async () => {
      if (nextLoading.value) {
        return;
      }

      sendLoading.value = true;
      countDown.value.start();
      countTime.value = true;
      const res = await registerSend({
        email: email.value
      });
      sendLoading.value = false;

      if (res.code === 200) {
        Toast({
          message: t('sendSuccess'),
          position: 'bottom'
        });
        return;
      }

      Toast({
        message: res.msg !== '' ? res.msg : t('sendError'),
        position: 'bottom'
      });
    };

    const finish = () => {
      countTime.value = false;
      countDown.value.reset();
    };

    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");

      const _component_van_count_down = _resolveComponent("van-count-down");

      const _component_van_button = _resolveComponent("van-button");

      const _component_a_input_password = _resolveComponent("a-input-password");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavGradient, {
        style: {
          "position": "fixed"
        }
      }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)('register')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('email')), 1), _createVNode(_component_a_input, {
        style: {
          "height": "40px",
          "font-size": "15px"
        },
        allowClear: "",
        placeholder: _unref(t)('emailInput'),
        value: email.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => email.value = $event)
      }, null, 8, ["placeholder", "value"]), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('emailCheck')), 1), _createVNode(_component_a_input, {
        style: {
          "height": "40px",
          "font-size": "15px"
        },
        value: checkCode.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => checkCode.value = $event),
        placeholder: _unref(t)('checkCodeInput')
      }, {
        suffix: _withCtx(() => [_withDirectives(_createElementVNode("span", {
          onClick: sendCheckCode,
          style: _normalizeStyle({
            color: nextLoading.value ? '#969799' : '#F08504'
          })
        }, _toDisplayString(_unref(t)('sendCheckCode')), 5), [[_vShow, !countTime.value]]), _withDirectives(_createVNode(_component_van_count_down, {
          ref_key: "countDown",
          ref: countDown,
          time: time.value,
          format: "ss",
          "auto-start": false,
          onFinish: finish,
          style: {
            "--van-count-down-text-color": "#969799"
          }
        }, null, 8, ["time"]), [[_vShow, countTime.value]])]),
        _: 1
      }, 8, ["value", "placeholder"]), _createVNode(_component_van_button, {
        color: "#F08504",
        block: "",
        onClick: showEmailCheck,
        style: {
          "margin": "22px 0 5px 0",
          "--van-button-default-height": "40px",
          "font-size": "17px",
          "--van-button-border-radius": "4px",
          "border-radius": "100px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('next')), 1)]),
        _: 1
      })], 512), [[_vShow, tabActive.value == 0]]), _withDirectives(_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(t)('register')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('setLoginPwd')), 1), _createVNode(_component_a_input_password, {
        class: "pwd-input",
        placeholder: _unref(t)('loginPwdInput'),
        allowClear: "",
        value: loginPwd.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => loginPwd.value = $event)
      }, null, 8, ["placeholder", "value"]), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('setFinancePwd')), 1), _createVNode(_component_a_input_password, {
        class: "pwd-input",
        placeholder: _unref(t)('setFinancePwd'),
        allowClear: "",
        value: financePwd.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => financePwd.value = $event)
      }, null, 8, ["placeholder", "value"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_button, {
        color: "#F08504",
        block: "",
        onClick: _cache[4] || (_cache[4] = $event => tabActive.value = 0),
        style: {
          "margin": "22px 0 5px 0",
          "--van-button-default-height": "40px",
          "font-size": "17px",
          "--van-button-border-radius": "4px",
          "width": "49%",
          "border-radius": "100px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('lastStep')), 1)]),
        _: 1
      }), _createVNode(_component_van_button, {
        color: "#F08504",
        block: "",
        onClick: next,
        style: {
          "margin": "22px 0 5px 0",
          "--van-button-default-height": "40px",
          "font-size": "17px",
          "--van-button-border-radius": "4px",
          "width": "49%",
          "border-radius": "100px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('register')), 1)]),
        _: 1
      })])], 512), [[_vShow, tabActive.value == 1]]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
        class: _normalizeClass(["item", {
          'active': tabActive.value == 0
        }])
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          'active': tabActive.value == 1
        }])
      }, null, 2)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        class: "login",
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).replace({
          name: 'login'
        }))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('loginText1')), 1), _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('loginText2')), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('registerPolicy')), 1)])])]), _createVNode(CheckPopup, {
        "check-show": checkShow.value,
        onHide: _cache[6] || (_cache[6] = $event => checkShow.value = false),
        email: email.value,
        captcha: captcha.value,
        "captcha-id": _ctx.captchaId,
        onNext: next,
        text: _unref(t)('register'),
        "next-loading": nextLoading.value
      }, null, 8, ["check-show", "email", "captcha", "captcha-id", "text", "next-loading"])]);
    };
  }

};